import './index.scss';
import React from 'react';
import { ElementIcon, IElementIconProps } from '../iconFontList/elementIcon';
import { lang } from '@umu/ukit-lang';
import { IMG_FILE_ACCEPTS } from '../../../../dataFlow';
import { Button } from '@umu/umu-design';
import { If } from 'common/src/components';
import { UploadFile } from '../../../uploadFile';
enum DIRECTION {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
}
interface IElementInfo extends IElementIconProps {
    btnProps?: React.HTMLAttributes<HTMLButtonElement>;
    btnRestProps?: React.HTMLAttributes<HTMLButtonElement>;
    titleText?: string | JSX.Element;
    btnText?: string;
    accept?: string;
    restText?: string;
    isAllowReset?: boolean;
}

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    direction?: DIRECTION;
    prefixCls?: string;
    info: IElementInfo | IElementInfo[];
    onResetFile?: (index: number) => void;
    onChooseFile: (ev: React.ChangeEvent<HTMLInputElement>, index: number) => void;
}

function ImgSelect(props: IProps) {
    const { info, className = '', prefixCls = 'navigation-img-select-content', direction = DIRECTION.VERTICAL, children, onResetFile, onChooseFile, ...rest } = props;
    const newPrefixCls = `${prefixCls}-${direction.toLocaleLowerCase()}`;

    const renderList = () => {
        const list = Array.isArray(info) ? info : [info];
        return list.map((item, index) => {
            const {
                btnText = lang('上传图标'),
                titleText = '',
                accept = IMG_FILE_ACCEPTS,
                btnProps,
                isAllowReset = false,
                restText = lang('重置'),
                btnRestProps = {},
            } = item;
            return (
                <div className={`${newPrefixCls}-custom-item`} key={`custom-img-${index}`}>
                    {titleText && <div className={`${newPrefixCls}-custom-item-title`}>{titleText}</div>}
                    <div className={`${newPrefixCls}-custom-item-info`}>
                        <div className={`${newPrefixCls}-icon-content-info ${newPrefixCls}-icon-col-split`}>
                            <ElementIcon {...item} />
                        </div>
                        <div className={`${newPrefixCls}-operate`}>
                            <UploadFile onChooseFile={(ev) => onChooseFile(ev, index)} accept={accept}>
                                <Button type="ghost-blue" className={`${newPrefixCls}-icon-col-split`} {...btnProps}>
                                    {btnText}
                                </Button>
                            </UploadFile>
                            <If condition={isAllowReset}>
                                <Button
                                    type="text"
                                    isOnlyChildren
                                    onClick={() => onResetFile && onResetFile(index)}
                                    {...btnRestProps}
                                >
                                    {restText}
                                </Button>
                            </If>
                        </div>
                    </div>
                </div>
            );
        });
    };
    return (
        <div className={`${newPrefixCls} ${className}`} {...rest}>
            <div className={`${newPrefixCls}-list`}>{renderList()}</div>
            {children}
        </div>
    );
}

export { ImgSelect, DIRECTION };
